import React from "react";
import "../Css/slider2.css";
import BannerImg from "../F-img/Banner-img.png";
import DedicatedChildren from "../Img/Final-images/introduction-right-img2.png";
import { Link } from "react-router-dom";
function Slider2() {
  return (
    <>
      <section className="slider-2 p-m">
        <div className="poster-container">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="right-p">
                  <h2 className="w-100">
                    Safe, Nurturing Homes where Children can
                    <br /> Heal
                    <span className="p-m"> Develop, and Thrive</span>
                  </h2>
                  <p className="text-center">
                    Ofsted regulated residential children’s homes offering
                    trauma informed, relationship based care.
                  </p>

                  <div className="hero-btns w-100">
                    <Link to="/referrals">
                      <button className="read-more-btn mx-3">
                        Make a Referral
                      </button>
                    </Link>
                    <Link to="/ourhome">
                      <button className="read-more-btn">View Our Homes</button>
                    </Link>
                  </div>
                </div>
              </div>

              {/*
              <div className="col-md-6">
                <div className="left-p">
                  <div className="image-container">
                    <img
                      src={BannerImg}
                      alt="Residential Childrens Home"
                      className="image image4"
                    />
                  </div>
                </div>
              </div>*/}
            </div>
          </div>
        </div>
      </section>

      <section className="text-center">
        <div className="container mt-5">
          <div className="row g-4 align-items-center">
            <div className="col-12 col-md-12">
              <h2 className="sub-heading text-center">Introduction</h2>
              <p className="text-center">
                Affinity Childrens Services Limited provides safe, stable, and
                nurturing residential homes for children and young people who
                have experienced trauma, disrupted attachments, or periods of
                instability. Our homes offer calm, consistent environments where
                children feel valued, listened to, and supported to grow
                emotionally, socially, and educationally.
              </p>

              <p className="text-center">
                We believe that every child deserves a home where they feel
                safe, respected, and understood. Our approach is grounded in
                strong relationships, predictable routines, and an understanding
                of how early experiences shape behavior and wellbeing.
              </p>
              <Link to="/about">
                <button className="read-more-btn">More About Us</button>
              </Link>
            </div>

            {/*<div className="col-12 col-md-6">
              <img
                src={DedicatedChildren}
                alt="improving Children’s Lives"
                className="w-100 img-radius img-fluid m-view"
              />
            </div>*/}
          </div>
        </div>
      </section>
    </>
  );
}

export default Slider2;
